import { DefaultService } from '@/services/DefaultService';

export default class PeriodoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(periodo) {
        return this._http.post(`${this._env}/promotor/period`, periodo, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    saveNew(dto) {
        return this._http.post(`${this._env}/promotor/period/new`, dto, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http
            .get(`${this._env}/promotor/period/${id}.json`, this._headers)
            .then((res) => {
                return res.body;
            }, this.handleError);
    }

    delete(id) {
        return this._http
            .delete(`${this._env}/promotor/period/${id}`, this._headers)
            .then((res) => {
                return res.body;
            }, this.handleError);
    }
}
